export class TransportRegistrationIdentity {
    vehicleId: number;
}
